import Vue from 'vue';

export default {
  TOGGLE_ADD_PARTNER_DIALOG: (state, payload) => {
    state.addPartnerDialog = payload;
  },
  TOGGLE_PARTNER_EDIT_DIALOG: (state, payload) => {
    state.partnerEditDialog = payload;
  },
  SET_ACTIVE_PARTNER_ID: (state, { compId, payload }) => {
    Vue.set(state.activePartnersIds, compId, payload);
  },
};


// WEBPACK FOOTER //
// ./src/store/partners/mutations.js